import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../components/global/Button';

const propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.node,
};

const VideoCardActionButton = ({ onClick, icon }) => {
  return (
    <Button
      btnStyle="reset"
      onClick={event => {
        event.preventDefault();
        onClick();
      }}
      className="video-card-action-button"
    >
      {icon}
    </Button>
  );
};

VideoCardActionButton.propTypes = propTypes;

export default VideoCardActionButton;
